import { Component, Input, OnInit } from '@angular/core';
import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { FormFieldAbstractComponent } from '../form-field-abstract.component';

@Component({
  selector: 'app-form-field-date',
  templateUrl: './form-field-date.component.html',
})
export class FormFieldDateComponent
  extends FormFieldAbstractComponent
  implements OnInit
{
  @Input() minDate?: Date = undefined;
  @Input() maxDate?: Date = undefined;

  ngOnInit(): void {
    this.applyValidators();
  }

  get minDateString(): string | null {
    return this.minDate
      ? this.formatDateForInput(this.minDate)
      : null;
  }

  get maxDateString(): string | null {
    return this.maxDate
      ? this.formatDateForInput(this.maxDate)
      : null;
  }

  get minDateFormatted(): string | null {
    return this.minDate
      ? this.formatDateToString(this.minDate)
      : null;
  }

  get maxDateFormatted(): string | null {
    return this.maxDate
      ? this.formatDateToString(this.maxDate)
      : null;
  }

  get showError(): boolean {
    return this.field.touched && !this.field.valid;
  }

  get hasValue(): boolean {
    return String(this.field.value || '').length > 0;
  }

  private applyValidators(): void {
    const validators = this.field.validator
      ? [this.field.validator]
      : [];
    if (this.minDate)
      validators.push(this.minDateValidator(this.minDate));
    if (this.maxDate)
      validators.push(this.maxDateValidator(this.maxDate));
    this.field.setValidators(validators);
    this.field.updateValueAndValidity();
  }

  private minDateValidator(min: Date): ValidatorFn {
    return (
      control: AbstractControl
    ): ValidationErrors | null => {
      if (!control.value) return null;
      const valueDate = new Date(control.value);
      return valueDate < min
        ? {
            minDate: {
              requiredMin: min,
              actual: valueDate,
            },
          }
        : null;
    };
  }

  private maxDateValidator(max: Date): ValidatorFn {
    return (
      control: AbstractControl
    ): ValidationErrors | null => {
      if (!control.value) return null;
      const valueDate = new Date(control.value);
      return valueDate > max
        ? {
            maxDate: {
              requiredMax: max,
              actual: valueDate,
            },
          }
        : null;
    };
  }

  private formatDateForInput(date: Date): string {
    // returns date in 'yyyy-mm-dd' format
    return date.toISOString().split('T')[0];
  }

  private formatDateToString(date: Date): string {
    // returns date in 'dd.mm.yyyy' format
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1)
      .toString()
      .padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  }
}
